var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[(_vm.anchor)?_c('h5',{staticClass:"subtitle text-uppercase m-0",attrs:{"id":_vm.anchor}},[_vm._v(_vm._s(_vm.subtitle))]):_c('h5',{staticClass:"subtitle text-uppercase m-0"},[_vm._v(_vm._s(_vm.subtitle))]),_c('h1',{staticClass:"title text-white text-uppercase",domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }